import { LotInfo } from "."

export default class LotInfoResponse {
  results: LotInfo[]
  count: number
  next: number
  previous: number

  constructor(
    results: LotInfo[] = [],
    count: number = 0,
    next: number = 0,
    previous: number = 0) {
    this.results = results
    this.count = count
    this.next = next
    this.previous = previous
  }
}